/*
  <megamenu-images> — horizontal gallery of submenu images.

  The track scrolls natively (touch, trackpad, Tab through the links); the
  arrows are a pointer convenience and are hidden when there is nothing left to
  scroll in that direction. Arrow state is recalculated through a
  ResizeObserver, so it also updates when the dropdown or drawer panel opens and
  the track goes from zero to its real width.
*/
class MegamenuImages extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-mmi-track]');
    this.arrows = this.querySelectorAll('[data-mmi-arrow]');
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    // no arrows in the drawer (swiped row) or in the grid: nothing to wire up
    if (!this.track || !this.arrows.length) return;

    this.track.addEventListener('scroll', this.update, { passive: true });

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        event.preventDefault();
        const direction = arrow.dataset.mmiArrow === 'next' ? 1 : -1;
        this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
      });
    });

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  update() {
    if (!this.track) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    this.arrows.forEach((arrow) => {
      if (arrow.dataset.mmiArrow === 'next') {
        arrow.disabled = this.track.scrollLeft >= maxScroll - 1;
      } else {
        arrow.disabled = this.track.scrollLeft <= 1;
      }
    });
  }
}

customElements.define('megamenu-images', MegamenuImages);
